import { cn } from 'utils/cn';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-lg bg-quinary-900', className)} {...props} />;
}

export default Skeleton;
